import { render, staticRenderFns } from "./search-giphy.vue?vue&type=template&id=5d00f4aa"
import script from "./search-giphy.vue?vue&type=script&lang=js"
export * from "./search-giphy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports